import { StatusLabelStatus } from '../../../../../../common/enums/statusLabelStatus';

export const consultationAdminLabels = [
    StatusLabelStatus.draftConsult,
    StatusLabelStatus.sentFirstRound,
    StatusLabelStatus.answeredFirstRound,
    StatusLabelStatus.sentSecondRound,
    StatusLabelStatus.answeredSecondRound,
    StatusLabelStatus.closed,
    StatusLabelStatus.cancelled,
    StatusLabelStatus.aborted,
];

export const examinationAdminLabels = [
    StatusLabelStatus.draftRequest,
    StatusLabelStatus.requested,
    StatusLabelStatus.withBiometrician,
    StatusLabelStatus.withPatient,
    StatusLabelStatus.dataTransferred,
    StatusLabelStatus.assetNeeded,
    StatusLabelStatus.withAnalysis,
    StatusLabelStatus.withGrader,
    StatusLabelStatus.completed,
    StatusLabelStatus.withSupervisor,
    StatusLabelStatus.supervised,
    StatusLabelStatus.closed,
    StatusLabelStatus.cancelled,
    StatusLabelStatus.aborted,
    StatusLabelStatus.withAdmin,
];

export const referralAdminLabels = [
    StatusLabelStatus.draftReferral,
    StatusLabelStatus.sent,
    StatusLabelStatus.accepted,
    StatusLabelStatus.rejected,
    StatusLabelStatus.rejectedAndResent,
    StatusLabelStatus.rejectedAndArchived,
    StatusLabelStatus.intakeDraft,
    StatusLabelStatus.intakeCompleted,
    StatusLabelStatus.intakeCompletedAdmin,
    StatusLabelStatus.dischargeDraft,
    StatusLabelStatus.dischargeCompleted,
    StatusLabelStatus.closed,
    StatusLabelStatus.cancelled,
    StatusLabelStatus.aborted,
];

export const contactAdminLabels = [
    StatusLabelStatus.draftContact,
    StatusLabelStatus.sent,
    StatusLabelStatus.cancelled,
    StatusLabelStatus.aborted,
];

export const counselingAdminLabels = [StatusLabelStatus.draftCounseling, StatusLabelStatus.cancelled];

export const invitationAdminLabels = [
    StatusLabelStatus.invited,
    StatusLabelStatus.started,
    StatusLabelStatus.closed,
    StatusLabelStatus.cancelled,
    StatusLabelStatus.aborted,
];
